import { render, staticRenderFns } from "./FulfillmentDetail.vue?vue&type=template&id=7829908e&scoped=true&"
import script from "./FulfillmentDetail.vue?vue&type=script&lang=js&"
export * from "./FulfillmentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7829908e",
  null
  
)

export default component.exports